<template>
  <div ref="integrations">
    <!-- integrations {{storeState.integrationCatalog.length}} -->
    <div v-if="!storeState.gotIntegrations">
      <template>
        <div class="tw-flex tw-justify-center">
          <div class="tw-pt-32">
            <v-progress-circular
              indeterminate
              :size="100"
              :width="8"
              color="primary"
            >
            </v-progress-circular>
          </div>
        </div>
      </template>
    </div>
    <div class="tw-grid tw-grid-cols-12 sm:tw-grid-cols-12 lg:tw-grid-cols-12" v-else-if="storeState.gotIntegrations && storeState.integrationCatalog.length > 0">
      <div class="tw-col-span-2">
        
      </div>
      <div class="tw-col-span-8">
        <div class="tw-grid lg:tw-grid-cols-3 sm:tw-grid-cols-1 tw-align-middle tw-mb-8 tw-mt-8 tw-gap-10">
          <div class="tw-relative tw-w-full tw-text-gray-400 focus-within:tw-text-gray-600 tw-col-span-2">
            <div class="tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pointer-events-none">
              <!-- Heroicon name: solid/search -->
              <svg class="tw-h-5 tw-w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"></path>
              </svg>
            </div>
            <input 
              id="search_field"
              class="tw-block tw-w-full tw-h-full tw-pl-8 tw-pr-3 tw-border-transparent tw-text-gray-900 tw-placeholder-gray-500 focus:tw-outline-none focus:tw-placeholder-gray-400 focus:tw-ring-0 focus:tw-border-transparent sm:tw-text-sm " placeholder="Search" type="search" name="search"
              autocomplete="off"
              v-model="searchTerm"
              >
          </div>
            <div class="lg:tw-text-center tw-col-span-1 sm:tw-text-sm ">
              <select v-model="Selected" class="dropdown-arrow"  > 
                <option v-for="(value,key) in options">{{ key }}</option>
              </select>
            </div>
          </div>
          <div>
            <ul class="tw-grid tw-grid-cols-1 tw-gap-6 sm:tw-grid-cols-2 lg:tw-grid-cols-3">
              <li 
                v-for="(integration, index) in integrationFilter(searchTerm,options[Selected])"
                :data-uuid="integration.id" 
                :key="integration.id" 
                class="tw-flex tw-flex-col tw-col-span-1 tw-bg-white tw-rounded-lg tw-shadow tw-list-none"
                :class="{}"
              > 
                <!-- {{integration}} -->
                <div class="tw-w-full tw-flex tw-items-center tw-justify-center tw-p-6 tw-space-x-6">
                    <div>
                      <img class="tw-h-16" style="max-height: 2.5rem;" :src="integration.details.logo_url" alt="">
                    </div>
                </div>
                <div class="tw-flex-1 tw-w-full tw-flex tw-items-center tw-justify-between tw-p-6 tw-pt-2 tw-space-x-6 tw-border-b">
                  <div class="tw-flex-1 ">
                    <div class="tw-flex tw-items-center tw-space-x-3">
                      <h3 class="tw-text-gray-900 tw-text-sm tw-font-medium ">{{integration.app_name}}</h3>
                      <span 
                        :class="{
                          'tw-bg-gray-200': true, 
                          'tw-text-gray-900': true,
                          'tw-text-green-800': getBadge(integration) === 'Premium',
                          'tw-bg-green-100': getBadge(integration) === 'Premium',
                        }"
                        class="tw-flex-shrink-0 tw-inline-block tw-px-2 tw-py-0.5  tw-text-xs tw-font-medium tw-rounded-full"
                        
                      >
                        {{getBadge(integration)}}
                      </span>
                    </div>
                    <p class="tw-mt-1 tw-text-gray-500 tw-text-sm ">{{integration.details.app_description}}</p>
                  </div>
                </div>
                <div>
                  <div class="tw--mt-px tw-flex tw-divide-x tw-divide-gray-200">
                    <div class="tw-w-0 tw-flex-1 tw-flex">
                      <a 
                        :href=integration.details.docs_link
                        target="_blank" 
                        class="tw-relative tw--mr-px tw-w-0 tw-flex-1 tw-inline-flex tw-items-center tw-justify-center tw-py-4 tw-text-sm tw-text-gray-700 tw-font-medium tw-border tw-border-transparent tw-rounded-bl-lg hover:tw-text-gray-500"
                      >
                        <!-- Heroicon name: solid/dots -->
                        <svg class="tw-w-5 tw-h-5 tw-text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z">
                          </path>
                        </svg>
                        <span class="tw-ml-3">Details</span>
                      </a>
                    </div>
                    <div class="tw--ml-px tw-w-0 tw-flex-1 tw-flex">
                      <a @click="addIntegration(integration)" class="tw-cursor-pointer tw-relative tw-w-0 tw-flex-1 tw-inline-flex tw-items-center tw-justify-center tw-py-4 tw-text-sm tw-text-gray-700 tw-font-medium tw-border tw-border-transparent tw-rounded-br-lg hover:tw-text-gray-500">
                        <!-- Heroicon name: solid/plus -->
                        <svg class="tw-w-5 tw-h-5 tw-text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6">
                          </path>
                        </svg>
                        <span class="tw-ml-3">Add</span>
                      </a>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
      </div>
      <div class="tw-col-span-2"></div>
    </div>
    <div> 
      <v-dialog :value="storeState.addingSource" v-model="storeState.addingSource" persistent retain-focus max-width="600px">
        <template v-slot:activator="{ on2 }">
          <!-- <button tabindex="-1" class="soup-btn right" @click="addSource" v-on="on2">
            <v-icon>mdi-plus</v-icon>
          </button> -->
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">New source</span>
          </v-card-title>
          <v-card-text v-if="newSource.db_type === 'bigquery'">
            <v-row>
              <v-col cols="12" sm="4" md="4">
                <v-select
                :items="dbTypes"
                v-model="newSource.db_type"
                item-text="label"
                item-value="key"
                label="Flavor"
                required
                outlined
                ></v-select>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-text-field 
                  ref="newSourceName"
                  v-model="newSource.name"
                  autocomplete="off"
                  :rules="[sourceRules.required, sourceRules.portMin]"
                  label="Nickname" 
                  hint="This can be anything you want"
                  class="source-input"
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field 
                  name="host"
                  ref="newSourceApiKey"
                  v-model="newSource.apiKey" 
                  autocomplete="off"
                  :rules="[sourceRules.required]"
                  label="Service Account Information (paste in JSON)"
                  class="source-input"
                  outlined
                  >
                </v-text-field>
                <div>
                  <a class="tw-text-blue-500" href="https://doc.seekwell.io/d349db8b1599451e8f78f2a66ac10a77" target="_blank">
                    Click here
                  </a> 
                  for help creating service account credentials
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text v-else-if="newSource.db_type === 'airtable'">
            <v-row>
              <v-col cols="12" sm="4" md="4">
                <v-select
                :items="dbTypes"
                v-model="newSource.db_type"
                item-text="label"
                item-value="key"
                label="Flavor"
                required
                outlined
                ></v-select>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-text-field 
                  ref="newSourceName"
                  v-model="newSource.name"
                  autocomplete="off"
                  :rules="[sourceRules.required, sourceRules.portMin]"
                  label="Nickname" 
                  hint="This can be anything you want"
                  class="source-input"
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field 
                  name="host"
                  ref="newSourceApiKey"
                  v-model="newSource.apiKey" 
                  autocomplete="off"
                  :rules="[sourceRules.required]"
                  label="API Key"
                  class="source-input"
                  outlined
                  >
                </v-text-field>
                <div>
                  Visit 
                  <a class="tw-text-blue-500" href="https://airtable.com/account" target="_blank">your Airtable account</a> 
                  to get your key (look for the "API" section)
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text v-else-if="newSource.db_type != 'snowflake'">
            <v-container>
              <v-row>
                <v-col cols="12" sm="4" md="4">
                  <v-select
                  :items="dbTypes"
                  v-model="newSource.db_type"
                  item-text="label"
                  item-value="key"
                  label="Flavor"
                  required
                  outlined
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="8" md="8">
                  <v-text-field 
                    ref="newSourceName"
                    v-model="newSource.name"
                    autocomplete="off"
                    :rules="[sourceRules.required, sourceRules.portMin]"
                    label="Nickname" 
                    hint="This can be anything you want"
                    class="source-input"
                    outlined
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="9" md="9">
                  <v-text-field 
                    name="host"
                    ref="newSourceHost"
                    v-model="newSource.host" 
                    autocomplete="off"
                    :rules="[sourceRules.required]"
                    label="Host" 
                    hint="Full host name or IP address"
                    class="source-input"
                    outlined
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <v-text-field 
                    v-model="newSource.port" 
                    ref="newSourcePort"
                    autocomplete="off"
                    :rules="[sourceRules.required, sourceRules.portMin]"
                    label="Port" 
                    :hint="portHint"
                    class="source-input"
                    outlined
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field 
                    name="search-username"
                    ref="newSourceUsername"
                    v-model="newSource.username" 
                    autocomplete="off"
                    :rules="[sourceRules.required]"
                    label="Username" 
                    class="source-input"
                    outlined
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <!-- <v-text-field :value="newSource.password" required password label="Password" ></v-text-field> -->
                  <v-text-field 
                    name="search-password"
                    type="password"
                    v-model="newSource.password" 
                    autocomplete="new-password"
                    label="Password" 
                    hint="Leave blank if no password"
                    class="source-input"
                    outlined
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="8" md="8">
                  <v-text-field 
                    name="search-database"
                    v-model="newSource.database" 
                    autocomplete="new-password"
                    label="Database"
                    :rules="[sourceRules.required]"
                    class="source-input"
                    outlined
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-checkbox
                    v-model="newSource.ssl"
                    label="Use SSL"
                    class="source-input"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="newSource.ssh"
                    label="Use SSH"
                    class="source-input"
                  ></v-checkbox>
                </v-col>
                <v-col v-if="newSource.ssh" cols="12" sm="6" md="6">
                  <!-- <v-text-field :value="newSource.password" required password label="Password" ></v-text-field> -->
                  <v-text-field 
                    name="sshHost"
                    v-model="newSource.sshHost" 
                    autocomplete="off"
                    :rules="[sourceRules.required]"
                    label="SSH Host" 
                    hint="e.g. e2c-123.amazonaws.com"
                    class="source-input"
                    outlined
                    >
                  </v-text-field>
                </v-col>
                <v-col v-if="newSource.ssh" cols="12" sm="6" md="6">
                  <v-text-field 
                    name="sshUsername"
                    v-model="newSource.sshUsername" 
                    autocomplete="off"
                    :rules="[sourceRules.required]"
                    label="SSH Username" 
                    class="source-input"
                    outlined
                    >
                  </v-text-field>
                </v-col>
                <v-col v-if="newSource.ssh" cols="12" sm="6" md="6">
                  <v-text-field 
                    name="search-ssh-password"
                    type="password"
                    autocomplete="new-password"
                    v-model="newSource.sshPassword"
                    label="SSH Password" 
                    class="source-input"
                    outlined
                    >
                  </v-text-field>
                </v-col>
                <v-col v-if="newSource.ssh" cols="12" sm="6" md="6">
                  <v-text-field 
                    name="sshPort"
                    v-model="newSource.sshPort" 
                    autocomplete="off"
                    label="SSH Port (Optional)" 
                    class="source-input"
                    outlined
                    >
                  </v-text-field>
                </v-col>
                <v-col v-if="newSource.ssh" cols="12" sm="12" md="12">
                  <v-textarea 
                    name="sshPrivateKey"
                    ref="sshPrivateKey"
                    v-model="newSource.sshPrivateKey" 
                    autocomplete="off"
                    label="Private Key (Optional)" 
                    class="source-input"
                    outlined
                    >
                  </v-textarea>
                  <div 
                    class="tw-text-red-500" 
                    v-if="newSource.sshPrivateKey && newSource.sshPrivateKey.includes('OPENSSH')"
                  >
                    You can't use an OPENSSH private key, 
                    <a 
                      href="https://www.notion.so/Knowledge-Base-7e6abd7243ca43ad863372a264c44452#898f84b394514f4d9928d7b540922ad8" 
                      target="_blank"
                    >
                      see here for details
                    </a>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" md="12" v-if="!needsHelp">
                  <p style="font-size: 16px;" :class="{'whitelist-error': whitelistError, }">
                    You need to whitelist our IP addresses (35.193.207.79 and 35.239.74.213) for your connection to work.</p>
                  <div @click="needsHelp=true" class="tw-text-blue-500 tw-cursor-pointer tw-font-bold tw-mt-3 tw-text-lg">
                    Need help with this?
                  </div>
                </v-col>
                <v-col cols="12" sm="12" md="12" v-else>
                  <div @click="sendToDev" class="tw-cursor-pointer tw-my-8 tw-px-6 tw-py-4 tw-bg-gray-300 tw-rounded-sm tw-shadow-lg">
                    <div class="tw-pr-32">
                      Get someone on your team to help
                    </div>
                    <div class="tw-float-right tw--mt-8">
                      <svg class="tw-h-10 tw-w-10" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" 
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" 
                        clip-rule="evenodd"></path>
                      </svg>
                    </div>
                  </div>
                  <div @click="goToDocumentation" class="tw-cursor-pointer tw-my-8 tw-px-6 tw-py-4 tw-bg-gray-300 tw-rounded-sm tw-shadow-lg">
                    <div class="tw-pr-32">
                      View our docs
                    </div>
                    <div class="tw-float-right tw--mt-8">
                      <svg class="tw-h-10 tw-w-10" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" 
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" 
                        clip-rule="evenodd"></path>
                      </svg>
                    </div>
                  </div>
                </v-col>
              </v-row>
              
            </v-container>
          </v-card-text>
          <v-card-text v-else>
            <v-container>
              <v-row>
                <v-col cols="12" sm="4" md="4">
                  <v-select
                  :items="dbTypes"
                  v-model="newSource.db_type"
                  item-text="label"
                  item-value="key"
                  label="Flavor"
                  required
                  outlined
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="8" md="8">
                  <v-text-field
                    ref="newSourceName"
                    v-model="newSource.name" 
                    autocomplete="off"
                    :rules="[sourceRules.required, sourceRules.portMin]"
                    label="Nickname" 
                    hint="This can be anything you want"
                    class="source-input"
                    outlined
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="9" md="9">
                  <v-text-field 
                    name="host"
                    ref="newSourceAccountName"
                    v-model="newSource.accountName" 
                    autocomplete="off"
                    :rules="[sourceRules.required]"
                    label="Account Name" 
                    hint="Do not include region"
                    class="source-input"
                    outlined
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <v-select
                    ref="newSourceRegion"
                    :items="snowRegions"
                    v-model="newSource.region"
                    :rules="[sourceRules.required]"
                    label="Region"
                    class="source-input"
                    required
                    outlined
                    ></v-select>
                </v-col>
                
                <v-col cols="12" sm="6" md="6">
                  <v-text-field 
                    name="search-username"
                    ref="newSourceUsername"
                    v-model="newSource.username" 
                    autocomplete="off"
                    :rules="[sourceRules.required]"
                    label="Username" 
                    class="source-input"
                    outlined
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <!-- <v-text-field :value="newSource.password" required password label="Password" ></v-text-field> -->
                  <v-text-field 
                    name="search-password"
                    type="password"
                    v-model="newSource.password" 
                    autocomplete="new-password"
                    label="Password" 
                    hint="Leave blank if no password"
                    class="source-input"
                    outlined
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field 
                    name="search-warehouse"
                    v-model="newSource.warehouse" 
                    autocomplete="off"
                    :rules="[sourceRules.required]"
                    label="Warehouse" 
                    class="source-input"
                    outlined
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field 
                    name="search-database"
                    v-model="newSource.database" 
                    autocomplete="new-password"
                    label="Database"
                    :rules="[sourceRules.required]"
                    class="source-input"
                    outlined
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field 
                    name="search-database"
                    v-model="newSource.schema" 
                    autocomplete="new-password"
                    label="Schema"
                    class="source-input"
                    outlined
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field 
                    name="search-database"
                    v-model="newSource.role" 
                    autocomplete="new-password"
                    label="Role"
                    hint="e.g. ADMIN"
                    class="source-input"
                    outlined
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field 
                    name="search-database"
                    v-model="newSource.authenticator" 
                    autocomplete="new-password"
                    label="Authenticator (optional)"
                    class="source-input"
                    outlined
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <a 
                    href="https://www.notion.so/Connecting-to-Snowflake-7f4dad25705948e7b7ec9a2fa1b164a5"
                    target="_blank"
                  >
                  <strong @click="needsHelp=true" class="tw-text-blue-500" style="font-size: 16px;">Need help finding this information?</strong>
                  </a>
                </v-col>
                <v-col v-if="needsHelp" cols="12" sm="12" md="12">
                  <div @click="sendToDev" class="tw-cursor-pointer tw-my-8 tw-px-6 tw-py-4 tw-bg-gray-300 tw-rounded-sm tw-shadow-lg">
                    <div class="tw-pr-32">
                      Get someone on your team to help
                    </div>
                    <div class="tw-float-right tw--mt-8">
                      <svg class="tw-h-10 tw-w-10" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" 
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" 
                        clip-rule="evenodd"></path>
                      </svg>
                    </div>
                  </div>
                  <div @click="goToDocumentation" class="tw-cursor-pointer tw-my-8 tw-px-6 tw-py-4 tw-bg-gray-300 tw-rounded-sm tw-shadow-lg">
                    <div class="tw-pr-32">
                      View our docs
                    </div>
                    <div class="tw-float-right tw--mt-8">
                      <svg class="tw-h-10 tw-w-10" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" 
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" 
                        clip-rule="evenodd"></path>
                      </svg>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <div v-if="connectError">
            <v-row>
              <div class="error--text connect-error">
                {{connectError}}
              </div>
            </v-row>
          </div>
          <div class="tw-flex tw-justify-end tw-pr-4 tw-pb-4">
            <v-btn class="tw-pr-4" color="blue darken-1" text @click="cancelAddSource">Cancel</v-btn>
            <v-btn class="tw-pr-4 tw-text-blue-500" color="blue darken-1" text @click="saveSource" :loading="savingSource">Save</v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import debounce from 'debounce'
import { store } from '../store.js';
import _ from 'lodash';

document.body.setAttribute('data-app', true)

export default {
  mounted() {
  },
  created() {
    this.storeState.block = JSON.parse(JSON.stringify(this.storeState.blockTemplate))
  },
  data() {
    return {
      Selected: 'All Integration',
      store: store,
      storeState: store.state,
      searchTerm: '',
      needsHelp: false,
      whitelistError: false,
      newSource: {
        name: '',
        db_type: 'mysql',
        host: '',
        port: '',
        ssl: false,
        username: '',
        password: '',
        database: '',
        metadata: false,
      },
      savingSource: false,
      dbTypes: [
        {key: 'mysql', label: 'MySQL', portHint: 'e.g. 3306'}, 
        {key: 'postgres',  label: 'Postgres', portHint: 'e.g. 5432'},
        {key: 'snowflake',  label: 'Snowflake'},
        {key: 'mssql',  label: 'MS SQL Server', portHint: 'e.g. 1433'},
        {key: 'redshift',  label: 'Redshift', portHint: 'e.g. 5439'},
        {key: 'bigquery',  label: 'BigQuery', portHint: 'na'},
        {key: 'airtable',  label: 'Airtable', portHint: 'na'},
      ],
      connectError: '',
      sourceRules: {
        required: value => !!value || 'Required.',
        portMin: v => v.length >= 2 || 'Min 2 characters',
        emailMatch: () => ('The email and password you entered don\'t match'),
      },
      fieldRules: {
        required: value => !!value || 'Required.',
        portMin: v => v.length >= 2 || 'Min 2 characters',
        isNum: v => !isNaN(v) || 'Must be a number, use -1 for last day of the month',
        emailMatch: () => ('The email and password you entered don\'t match'),
      },
      snowRegions: [
        //https://docs.snowflake.com/en/user-guide/intro-regions.html#specifying-region-information-in-your-account-hostname
        //aws
        "us-west-1", 
        "us-west-2", 
        "us-east-1", 
        "us-east-2.aws", 
        "us-east-1-gov.aws",
        "eu-west-1", 
        "eu-central-1", 
        "ca-central-1.aws", 
        "ap-southeast-1", 
        "ap-southeast-2", 
        "ap-northeast-1.aws",
        //azure
        "us-east-2.azure", 
        "east-us-2.azure", 
        "west-us-2.azure",
        "us-gov-virginia.azure", 
        "canada-central.azure",
        "west-europe.azure", 
        "australia-east.azure",
        "southeast-asia.azure",
        //gcp
        "us-central1.gcp", 
        "europe-west2.gcp", 
        "europe-west4.gcp", 
      ],
      options: {'All Integration':'','Source':'Source','Destination':'Destination'}
    };
  },
  filters: {
    dateFilter: function (date) {
      console.log(date)
      date = date.fromNow()
      return date
      // return moment(date).fromNow();
    }
  },
  computed: {
    portHint: function () {
      let hint = this.dbTypes.find(d => d.key === this.newSource.db_type).portHint
      return hint || ''
    },
  },
  watch: {
    'storeState.blockListOpen': {
        handler: function (val, oldVal) {
          this.hoverBlock = false
        },
        deep: false
    },
  },
  methods: {
    validateSource() {
      //all
      if (this.newSource.db_type === 'airtable') {
        this.storeState.block.cellType = 'airtableAsSql'
        if (this.newSource.apiKey) {
          return true
        } else {
          this.$refs.newSourceApiKey.focus()
          return false
        }
      }
      if (this.newSource.db_type === 'bigquery') {
        // this.storeState.block.cellType = 'bigquery'
        if (this.newSource.apiKey) {
          return true
        } else {
          this.$refs.newSourceApiKey.focus()
          return false
        }
      }
      if (!this.newSource.name) {
        this.$refs.newSourceName.focus()
        return false
      }
      if (!this.newSource.username) {
        this.$refs.newSourceUsername.focus()
        return false
      }
      //not snowflake
      if (this.newSource.db_type != 'snowflake' && (!this.newSource.port || isNaN(this.newSource.port))) {
        this.$refs.newSourcePort.focus()
        return false
      }
      if (this.newSource.db_type != 'snowflake' && !this.newSource.host) {
        this.$refs.newSourceHost.focus()
        return false
      }
      if (this.newSource.db_type != 'snowflake' && (this.newSource.host.startsWith('https:') || this.newSource.host.startsWith('http:'))) {
        this.$refs.newSourceHost.focus()
        this.connectError = 'Do not include HTTP / HTTPS in the host name'
        return false
      }
      if (this.newSource.db_type != 'snowflake' && (
            this.newSource.ssh) && this.newSource.sshPrivateKey && 
            this.newSource.sshPrivateKey.includes('OPENSSH')) {
        this.$refs.sshPrivateKey.focus()
        this.connectError = `You can't use an OPENSSH private key, use an RSA key instead`
        return false
      }
      //snowflake
      if (this.newSource.db_type === 'snowflake' && !this.newSource.accountName) {
        this.$refs.newSourceAccountName.focus()
        return false
      }
      if (this.newSource.db_type === 'snowflake' && !this.newSource.region) {
        this.$refs.newSourceRegion.focus()
        return false
      }
      return true
    },
    saveSource() {
      let valid = this.validateSource()
      if (!valid) return
      const path = store.getPath('/soup_save_source')
      const d = this.newSource
      d.sessionId = this.storeState.sessionId
      var self = this
      self.savingSource = true
      axios.post(path, d)
        .then((res) => {
          console.log('got soup_save_source: ', res.data)
          self.storeState.block.source.uuid = res.data.block_uuid
          self.testRunSource(self)
        })
        .catch((error) => {
          self.savingSource = false
          self.storeState.snackbar = true;
          self.storeState.message = error;
        })
    },
    timeoutTest(self) {
      if (self.savingSource) {
        self.whitelistError = true
        self.savingSource = false
        self.storeState.snackbar = true;
        self.storeState.message = 'Connection took longer than 15 seconds, check your connection properties and try again';
      }
    },
    testRunSource(self) {
      if (this.newSource.db_type != 'airtable') self.storeState.block.cellType = 'sql'
      let block = store.cleanUpBlock(self.storeState.block);
      let data = {
        sessionId: self.storeState.sessionId,
        block: block,
        test: true
      }
      setTimeout(() => {
        self.timeoutTest(self)
      }, 15000);
      axios.post(store.getPathRunner('/run_one'), data)
        .then((res) => {
          if (res.data.ok) {
            console.log('testRunSource: ', res.data)
            self.storeState.addingSource = false
            self.savingSource = false
            self.storeState.snackbar = true;
            self.storeState.message = 'Source added!';
            self.$parent.getSoupSources()
          } else {
            console.error('testRunSource error: ', res.data)
            self.savingSource = false
            self.storeState.snackbar = true
            let err = res.data.error.replace('<', '')
            self.storeState.message = err
            self.connectError = err
          }
        })
        .catch((error) => {
          console.error('runCode error', error)
          self.savingSource = false
          self.storeState.snackbar = true;
          self.storeState.message = error;
        })
    },
    getBadge(integration) {
      if (!integration.details) return 'Standard'
      if (integration.details.status === 'none') {
        return 'Roadmap'
      }
      return integration.details.type
    },
    integrationFilter(searchTerm,integration_option){
      if(this.storeState.integrationCatalog){
        if (searchTerm =='' && integration_option=='')
        {
          return this.storeState.integrationCatalog.filter(integ => (integ.details.app_description || integ.app_name).toString().toLowerCase().includes(searchTerm.toString().toLowerCase()));
        }
        else if (searchTerm !='' && integration_option=='')
        {
          return this.storeState.integrationCatalog.filter(integ => (integ.details.app_description || integ.app_name).toString().toLowerCase().includes(searchTerm.toString().toLowerCase()));
        }
        else if (searchTerm =='' && integration_option!='')
        {
        return this.storeState.integrationCatalog.filter(integ => (integ.details.source_destination_flag).toLowerCase().includes(integration_option.toLowerCase()));
        }
        else if (searchTerm !='' && integration_option!='')
          {
            return this.storeState.integrationCatalog.filter(integ => ((integ.details.app_description || integ.app_name).toString().toLowerCase().includes(searchTerm.toString().toLowerCase()) && (integ.details.source_destination_flag).toLowerCase().includes(integration_option.toLowerCase())));
        }
      }
    },
    addIntegration(integration) {
      if (integration.details.source_destination_flag === 'source') {
        this.addSource()
      } else if (integration.details.addInApp) {
        this.addInApp(integration)
      } else if (integration.details.auth_link && integration.details.auth_link.length > 0) {
        window.open(integration.details.auth_link, '_blank');
      } else {
        // this.storeState.showHelp = true
        let domain = this.storeState.settings.user.me.email.split('@')[1]
        let link = `mailto:contact@seekwell.io?&subject=Add%20${integration.app_name}`
        link += `&body=Add%20${integration.app_name}%20for%20${domain}`
        window.open(link, '_blank');
      }
    },
    addInApp(integration) {
      console.log('addInApp: ', integration)
      this.storeState.cmdkParentCmd = `addIntegration`
      this.storeState.cmdkActive = true
      this.storeState.pendingIntegration = integration
    },
    cancelAddSource() {
      this.storeState.addingSource = false
      this.savingSource = false
    },
    addSource() {
      console.log('adding source...')
      this.storeState.addingSource = true
    },
    editSources() {
      console.log('edit source...')
      this.$router.push({ name: 'Sources' }).catch(err => console.error(err))
    },
  },
};
</script>

<style>
.dropdown-arrow { /*container for Integration dropdown arrow*/
  -webkit-appearance: none;
  padding: 2px 20px 2px 2px;
  border: none;
  background-image: url("https://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png");
 background-repeat: no-repeat;
 background-position: right center;
}
</style>
